import { FeatureAppEnvironment } from '@feature-hub/core';
import { ObservableHint, observable } from '@legendapp/state';

import { VisualizerFeatureAppDependencies } from '../../hooks/use-feature-services';

import { AbTestFeatures } from './tracking/types';

import { ApplicationConfig } from '../../environment';
import { RequiredFeatureServicesInternal } from '../../feature-app';

type VisualizerAppEnv = FeatureAppEnvironment<VisualizerFeatureAppDependencies, ApplicationConfig>;

/*
ConfiguredInterior = {
  interiorCode: "gti--F56_UG",
}
*/
interface ConfiguredInterior {
	interiorCode: string;
	comment?: string;
}

/*
ConfiguredColor = {
  colorCode: "0Q0Q",
}
*/
interface ConfiguredColor {
	colorCode: string;
	comment?: string;
}

/*
ConfiguredRim = {
  rimCode: "CV1",
}
*/
interface ConfiguredRim {
	rimCode: string;
	comment?: string;
}

/*
ConfiguredTrim = {
  trimCode: "style",
}
*/
interface ConfiguredTrim {
	trimCode: string;
	comment?: string;
}

/**
 * Configuration provided by the CMS via CMS "content".
 * This configuration is consumed via the FeatureApp Content Service.
 *
 * CMS does not support boolean value !!!
 *
 * Creating new type which must be parsed as boolean, update use-fa-content-service
 */
// @TODO this type is wrong
export interface FeatureAppConfig {
	gmcBundleId: string;
	gmcBundleVersion: string;
	gmcBundleIdOptionB?: string;
	gmcBundleVersionOptionB?: string;
	sortColors?: ConfiguredColor[];
	sortRims?: ConfiguredRim[];
	sortTrims?: ConfiguredTrim[];
	sortInteriors?: ConfiguredInterior[];
	excludeColors?: ConfiguredColor[];
	excludeRims?: ConfiguredRim[];
	excludeTrims?: ConfiguredTrim[];
	excludeInteriors?: ConfiguredInterior[];
}

interface FeatureAppStore {
	gmcBundleId?: string;
	gmcBundleVersion?: string;
	abTestFeatures: AbTestFeatures;
	apiKey?: string;
	featureServices?: RequiredFeatureServicesInternal;
	featureAppId?: string;
	featureAppEnv?: VisualizerAppEnv;
}

export const featureAppStore = observable<FeatureAppStore>({
	gmcBundleId: undefined,
	gmcBundleVersion: undefined,
	abTestFeatures: { '360cameraFlight': false },
	apiKey: undefined,
	featureServices: undefined,
	featureAppId: undefined,
	featureAppEnv: undefined
});

export const featureAppStoreActions = {
	setFeatureServices: (env: VisualizerAppEnv, faContent?: FeatureAppConfig) => {
		if (faContent) {
			featureAppStore.assign(faContent);
		}
		featureAppStore.featureAppEnv.set(ObservableHint.opaque(env));

		// @ts-ignore
		featureAppStore.featureServices.set(ObservableHint.opaque(env.featureServices));
		featureAppStore.featureAppId.set(env.featureAppId);
	},
	applyAbTestResolution: (resolved: { bundleId: string; bundleVersion: string; is360CameraFlight: boolean }) => {
		featureAppStore.gmcBundleId.set(resolved.bundleId);
		featureAppStore.gmcBundleVersion.set(resolved.bundleVersion);
		featureAppStore.abTestFeatures.set({ '360cameraFlight': resolved.is360CameraFlight });
	},
	getServiceConfig: (serviceConfig: string) => {
		const featureServices = featureAppStore.featureServices.get();
		if (!featureServices) return;

		const { configs } = featureServices['service-config-provider'];

		return configs[serviceConfig];
	}
};
